import React, { useState, useEffect } from "react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("gatsby-gdpr-google-analytics");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("gatsby-gdpr-google-analytics", true);
    localStorage.setItem("gatsby-gdpr-facebook-pixel", true);
    localStorage.setItem("gatsby-gdpr-hotjar", true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("gatsby-gdpr-google-analytics", false);
    localStorage.setItem("gatsby-gdpr-facebook-pixel", false);
    localStorage.setItem("gatsby-gdpr-hotjar", false);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div
      className="fixed bg-teal z-50"
      style={{
        position: "fixed",
        bottom: "-5px",
        width: "100%",
        color: "#fff",
        padding: "1rem",
        textAlign: "center",
      }}
    >
      <p>
        This website uses cookies to improve your experience. Do you accept ?
        <a href="/privacy/" className="ml-2 text-white">
          Privacy Policy
        </a>
      </p>
      <button
        onClick={handleAccept}
        style={{ marginRight: "1rem", cursor: "pointer" }}
      >
        Accept
      </button>
      <button
        style={{ marginRight: "1rem", cursor: "pointer" }}
        onClick={handleDecline}
      >
        Decline
      </button>
    </div>
  );
};

export default CookieBanner;
